<template>
  <b-field :horizontal="horizontal" label="Problem">
    <b-select v-model="value" @input="onInput" expanded :multiple="multiple" :disabled="loading" :loading="loading">
      <option value="" v-if="!multiple">
        <slot name="defaultOptionLabel">Please Select</slot>
      </option>
      <option v-for="option in options" :value="option.id" :key="option.id">
        {{ `${option.group.slice(-2)} ${option.name}` }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import { CodeService } from "@/services/code.service.js";

export default {
  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    value: "",
    options: [],
    loading: false
  }),
  created() {
    this.fetchOptions();
    this.reset();
  },
  methods: {
    fetchOptions() {
      this.loading = true;

      CodeService.all({
        type: "problem"
      }).then(
        response => {
          this.options = JsonDenormalizer.denormalize(response);
          this.loading = false;
        },
        err => {
          this.loading = false;
        }
      );
    },
    onInput() {
      this.$emit("input", this.value);
    },
    reset() {
      this.value = this.multiple ? [] : "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/VettedStatement/list/partials/selectProblem.vue